module.exports = __webpack_public_path__ + "static/media/TJ-Interior-LOGO.e0eb1254.png";